import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

export default function Auth() {
  const { signInWithGoogle, user, loading } = useAuth();

  const handleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error('[AUTH] Error signing in:', error);
    }
  };

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (user) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        gap={3}
        p={3}
      >
        <Typography variant="h6" component="h1" gutterBottom>
          You are signed in
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={3}
      p={3}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        Sign in to Cover Letter Generator
      </Typography>
      <Button
        variant="contained"
        size="large"
        onClick={handleSignIn}
        startIcon={<GoogleIcon />}
      >
        Sign in with Google
      </Button>
    </Box>
  );
}
